/* eslint-disable no-undef */

const parse = JSON.parse;
const stringify = JSON.stringify;

export const getItem = (key) => {
    if (!window) return null;
    return parse(localStorage.getItem(key)) || null;
};

export const setItem = (value, key) => {
    if (!value || !window) {
        return null;
    }
    return localStorage.setItem(key, stringify(value));
};

export const clearItem = (key) => {
    if (!window) return null;
    return localStorage.removeItem(key);
};

export const getStringItem = (key) => {
    if (!window) return null;
    return localStorage.getItem(key) || null;
};
